import React, { useEffect, useState, useContext } from "react";
import { adminAxios } from "../../axiosInstance";
import loader from "../../assets/loader.webp";
import EditProfile from "./EditProfile";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import CurrencySetting from "./CurrencySetting";
import { fetchOnlyData } from "../../utility/adminApi";
import CategoryIcon from "@mui/icons-material/Category";
import { useQuery } from "@tanstack/react-query";
import EditReceiptTemplate from "./EditReceiptTemplate";
import DownloadSalesCheckbox from "./DownloadSalesCheckbox";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import LowStockLimitModal from "./LowStockLimitModal";
import { ProfileDetailsContext } from "../../context/ProfileDetailsProvider";
import ProfileSaleStats from "./ProfileSaleStats";

function Profile() {
  const { profileDetails } = useContext(ProfileDetailsContext);

  const [viewModal, setViewModal] = useState(false);
  const [lowStockLimitModal, setLowStockLimitModal] = useState(false);
  const [editTab, setEditTab] = useState(false);
  const [profileData, setProfileData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [currencySymbol, setCurrencySymbol] = useState("");

  const { data: template, error } = useQuery({
    queryKey: ["admintemplate"],
    keepPreviousData: true,
    queryFn: () => fetchOnlyData("receipt-template"),
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const fetchData = async () => {
    try {
      const response = await adminAxios.get("/users/profile");
      setProfileData(response?.data?.data);
    } catch (err) {
      console.log("Error fetching data", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  console.log(profileDetails);
  console.log("we are on the profile page");

  if (isLoading) {
    return (
      <div className="w-full h-screen  flex justify-center items-center">
        <img src={loader} alt="loader" className=" w-10 lg:w-20 " />
      </div>
    );
  }
  return (
    <div className="lg:overflow-y-hidden ">
      {/* Header */}
      <div className="flex flex-col lg:flex-row justify-between mb-6 items-center w-full border-b-2 pb-2">
        <h3 className="text-xl font-semibold">Profile</h3>
        <div className="flex gap-6">
          <button
            onClick={() => setEditTab(true)}
            className="p-4 rounded-lg text-white bg-green-500"
          >
            Edit Profile
          </button>
        </div>
      </div>

      {editTab && (
        <EditProfile
          singleData={profileData}
          setEdittab={setEditTab}
          fetchProfile={fetchData}
          setIsLoading={setIsLoading}
          setSingleData={setProfileData}
        />
      )}

      {!editTab && (
        <div className="flex flex-col">
          <ProfileSaleStats currencySymbol={currencySymbol} />

          <div className="flex flex-col my-6 border-t-2">
            <div className="text-xl font-semibold my-2">
              <h2>Profile Details</h2>
            </div>
            <div className="flex gap-3 flex-col lg:grid lg:grid-cols-2 w-full">
              {/* <h2 className="text-xl font-semibold">Profile Details</h2> */}
              <div className="flex flex-col flex-1 ">
                <h3 className="font-medium">First Name:</h3>
                <h4 className="text-base py-2 border border-gray-600 rounded-md pl-2">
                  {profileData?.firstname}
                </h4>
              </div>

              <div className="flex flex-col flex-1">
                <h3 className="font-medium">Last Name:</h3>
                <h4 className="text-base py-2 border border-gray-600 rounded-md pl-2">
                  {profileData?.lastname}
                </h4>
              </div>
              <div className="flex flex-col flex-1">
                <h3 className="font-medium">Email:</h3>
                <h4 className="text-base py-2 border border-gray-600 rounded-md pl-2">
                  {profileData?.email}
                </h4>
              </div>

              <div className="flex flex-col flex-1">
                <h3 className="font-medium">Phone Number: </h3>
                <h4 className="text-base py-2 border border-gray-600 rounded-md pl-2">
                  {profileData?.phoneno}
                </h4>
              </div>
              <div className="flex flex-col flex-1">
                <h3 className="font-medium">Address:</h3>
                <h4 className="text-base py-2 border border-gray-600 rounded-md pl-2">
                  {profileData?.address}
                </h4>
              </div>
            </div>
            {/* <div>
              {profileData?.image == !null ? (
                <img src={profileData.image} />
              ) : (
                <AccountBoxIcon sx={{ fontSize: "250px", color: "grey" }} />
              )}
            </div> */}
          </div>

          <div className="flex flex-col gap-4 border-t-2 mt-2">
            <div className="text-center text-3xl text-red-600 font-semibold">
              App Settings
            </div>
            <div className="flex flex-col flex-wrap gap-3 ">
              <div className="flex justify-between gap-3">
                <h4 className="text-base py-2 border border-gray-600 rounded-md pl-2 flex flex-row gap-2  p-2 items-center flex-1">
                  {" "}
                  <CategoryIcon />
                  Receipt Template Setting
                </h4>
                <button
                  onClick={() => setViewModal(true)}
                  className="p-4 rounded-lg text-white bg-green-500"
                >
                  <span>Edit Receipt template</span>
                </button>
              </div>

              <div className="flex justify-between gap-3">
                <h4 className="text-base py-2 border border-gray-600 rounded-md pl-2 flex flex-row gap-2  p-2 items-center flex-1">
                  {" "}
                  <ProductionQuantityLimitsIcon />
                  Low Stock Limit Setting
                </h4>
                <button
                  onClick={() => setLowStockLimitModal(true)}
                  className="p-4 rounded-lg text-white bg-green-500"
                >
                  <span>Edit Low limit</span>
                </button>
              </div>

              <CurrencySetting setCurrencySymbol={setCurrencySymbol} />
            </div>
            <div className="bg-gray-50 p-6 rounded shadow border ">
              <h4 className="text-lg font-semibold text-gray-800">
                {" "}
                Monthly Data Analytics Consent
              </h4>
              <h3 className="text-red-400 text-sm">
                {" "}
                Description: To improve reporting and business insights, we
                offer an option to download and process your monthly sales data.
                By enabling this option, you consent to the secure collection
                and analysis of transaction data for better business decisions.
              </h3>
              <DownloadSalesCheckbox id={profileData?.company_id} />
            </div>
          </div>
        </div>
      )}
      {viewModal && (
        <EditReceiptTemplate template={template} setViewModal={setViewModal} />
      )}
      {lowStockLimitModal && (
        <LowStockLimitModal
          setLowStockLimitModal={setLowStockLimitModal}
          id={profileData?.company_id}
          fetchData={fetchData}
          profileDetails={profileDetails}
        />
      )}
    </div>
  );
}

export default Profile;
